import { useCallback } from 'react';
import { useAuth } from '@kts/client';
import { currentLocale, setLocale, storedLocale, useLocale } from '@kts/i18n';
import { isLocale, type Locale } from '@kts/shared';
import { api } from './api';

/** Serverga yozish faqat kirgan foydalanuvchida (kirish sahifasida 401 bermasin). */
async function saveToServer(locale: Locale) {
  if (useAuth.getState().status !== 'authed') return;
  await api.put('/me/prefs', { locale }).catch(() => undefined);
}

/**
 * Til boshqaruvi.
 *
 * Tanlov ikki joyda saqlanadi:
 *  - brauzerda (localStorage) — kirishdan oldin ham ishlasin, sahifa yangilanganda miltillamasin;
 *  - serverda (`users.locale`) — boshqa qurilmada ham o'sha til ochilsin, bildirishnoma/xat/bot
 *    matnlari ham shu tilda bo'lsin.
 *
 * Kirmagan foydalanuvchida serverga yozilmaydi (xato ham bermaydi).
 */
export function useAppLocale() {
  const locale = useLocale();
  const change = useCallback(async (next: Locale) => {
    await setLocale(next);
    // Serverga saqlash — ixtiyoriy, xato bo'lsa til baribir almashgan qoladi.
    await saveToServer(next);
  }, []);
  return { locale, setLocale: change };
}

/**
 * Kirgandan keyin tilni serverdagi qiymat bilan moslash.
 *
 * Qurilmada ataylab tanlangan til ustun turadi (masalan, kirish sahifasida inglizchaga o'tib
 * keyin login qilingan) — bunda serverdagi qiymat yangilanadi. Tanlov bo'lmasa — server tili qo'llanadi.
 */
export async function applyServerLocale(saved: unknown): Promise<void> {
  if (saved == null) return; // kirilmagan — sinxronlashga hojat yo'q
  const server = isLocale(saved) ? saved : null;
  const picked = storedLocale();
  if (picked) {
    if (server !== picked) await saveToServer(picked);
    return;
  }
  if (server && server !== currentLocale()) await setLocale(server, false);
}

export { currentLocale };
